<template>
  <div>
    <div class="d-flex justify-space-between align-top mb-3 flex-wrap">
      <h2 class="headline mb-3">{{ $t("collecte.participants") }}</h2>
      <div v-if="notEmptyMessages.length > max">
        <v-btn color="primary" v-if="!all" text @click="all = true">{{ $t("collecte.voirTousLesMessages") }} ({{ notEmptyMessages.length }})</v-btn>
        <v-btn color="primary" v-if="all" text @click="all = false"> {{ $t("collecte.voirLesDerniersMessages", { n: max }) }} </v-btn>
      </div>
    </div>

    <v-row v-if="notEmptyMessages.length > 0">
      <v-col cols="12" md="4" v-for="participant in showed" :key="participant.id">
        <v-sheet class="pa-3" rounded>
          <h2 class="title">{{ participant.message }}</h2>
          <p class="caption text-right mb-0">
            <span v-if="!participant.montantMasque && participant.montantDuDon > 0">{{ participant.montantDuDon | money }}</span>
            <span v-if="!participant.anonyme && participant.nom">{{ $t("collecte.de") }} {{ participant.nom }}</span>
          </p>
        </v-sheet>
      </v-col>
    </v-row>
    <p v-else>
      {{ $t("collecte.aucunMessage") }}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      max: 3,
      all: false
    }
  },
  props: {
    participants: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    notEmptyMessages() {
      return this.participants.filter((p) => p.message)
    },
    showed() {
      if (this.all) {
        return this.notEmptyMessages
      }
      return this.notEmptyMessages.filter((p, index) => index <= this.max - 1)
    }
  }
}
</script>

<style>
</style>